/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ days: NonNullable<unknown> }} Tournaments_Lib_Starts_In_DaysInputs */



/**
* | output |
* | --- |
* | "in {days} days" |
*
* @param {Tournaments_Lib_Starts_In_DaysInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const tournaments_lib_starts_in_days = /** @type {((inputs: Tournaments_Lib_Starts_In_DaysInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Lib_Starts_In_DaysInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`in ${i?.days} Tagen`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`dans ${i?.days} jours`)
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ (`${i?.days}天后`)
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ (`${i?.days} 天後`)
	if (locale === "ko") return /** @type {LocalizedString} */ (`${i?.days}일 후`)
	return /** @type {LocalizedString} */ (`in ${i?.days} days`)
});